var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:mail-48-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.875 10.61V21.0938C26.875 22.9062 25.4062 24.375 23.5938 24.375H6.40625C5.53601 24.375 4.70141 24.0293 4.08606 23.4139C3.4707 22.7986 3.125 21.964 3.125 21.0938V10.61L14.6238 16.935C14.8581 17.0638 15.1425 17.0638 15.3762 16.935L26.875 10.61ZM23.5938 5.625C24.4503 5.62508 25.2729 5.9601 25.8857 6.55849C26.4986 7.15687 26.8532 7.9712 26.8738 8.8275L15 15.3587L3.12625 8.82688L3.1275 8.77063C3.1625 7.92454 3.52325 7.12474 4.13432 6.53849C4.74538 5.95223 5.55944 5.62492 6.40625 5.625H23.5938Z",
    fill: "#E3AA03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.25a8e8104dae0d0d5f9d19017a5b98a4.svg";
export { ForwardRef as ReactComponent };